import React from "react";
import "./PortfolioPage.scss";

const PortfolioPage = () => {
  return <h1>PortfolioPage</h1>;
};

export default PortfolioPage;
